import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import './index.css';

const MessageBar = props => {
  const { SvgIcon, message, theme } = props;

  const messageBarCSS = cn(
    'message_bar',
    theme ? theme.map(css => `message_bar--${css}`).join(' ') : ''
  );

  return (
    <div data-testid="MessageBox" className={messageBarCSS}>
      {SvgIcon && (
        <div className="message_bar__icon">
          <SvgIcon width="18px" height="18px" />
        </div>
      )}
      <div className="message_bar__message">{message}</div>
    </div>
  );
};

MessageBar.propTypes = {
  SvgIcon: PropTypes.func,
  message: PropTypes.string.isRequired,
  theme: PropTypes.array,
};

MessageBar.defaultProps = {
  SvgIcon: null,
  theme: [],
};

export default MessageBar;



// WEBPACK FOOTER //
// ./src/common/components/MessageBar/index.js